const Config = {
  APP_VALIDATION_API: 'https://validation-api.trustedsource.co.za'
}
export { Config }
